/* One opt-in rail only. Cards remain the theme's native, interactive cards. */
(() => {
  if (window.mumusoRecentRails) return;
  window.mumusoRecentRails = true;

  const category = (item) => {
    const text = `${item.dataset.recentCategory} ${item.dataset.recentTitle}`.toLowerCase();
    if (/plüsch|pluesch|kuscheltier|puppe|plush|blind box|schlüsselanhänger|taschenanhänger/.test(text)) return 'plush';
    if (/haargummi|haarband|haarklammer|haarspange|scrunchie|schmuck|halskette|ohrring|armband|sonnenbrille|strohhut|handykette|handyanhänger/.test(text)) return 'accessories';
    if (/pflege|gesicht|maske|reinigung|haut|kamm|bürste|serum|creme|toner|skin|wascharm/.test(text)) return 'skincare';
    if (/make-up|makeup|puder|primer|lip|highlighter|augenbrauen|pinsel|beauty/.test(text)) return 'makeup';
    if (/haushalt|wohnen|küche|trink|kissen|handtuch|regenschirm|aufbewahrung/.test(text)) return 'home';
    return 'other';
  };
  const select = (items, count) => {
    const unique = [...new Map(items.map(item => [item.dataset.recentProduct, item])).values()];
    unique.sort((a, b) => Number(b.dataset.recentCreated) - Number(a.dataset.recentCreated));
    // Bound randomness to the 96 newest eligible items, and favour the newest
    // eight within each category. Older catalogue items cannot displace new arrivals.
    const groups = new Map();
    unique.slice(0, 96).forEach(item => {
      const key = category(item);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    });
    const result = [];
    let previous;
    while (result.length < count) {
      let keys = [...groups.keys()].filter(key => groups.get(key).length && key !== previous);
      if (!keys.length) keys = [...groups.keys()].filter(key => groups.get(key).length);
      if (!keys.length) break;
      // Cycle through all available categories before repeating one.
      const used = new Set(result.slice(-groups.size).map(category));
      const unused = keys.filter(key => !used.has(key));
      if (unused.length) keys = unused;
      const key = keys[Math.floor(Math.random() * keys.length)];
      const group = groups.get(key);
      const rank = Math.floor(Math.pow(Math.random(), 2) * Math.min(8, group.length));
      result.push(group.splice(rank, 1)[0]);
      previous = key;
    }
    return result;
  };
  const initialise = async (rail) => {
    if (rail.dataset.recentReady) return;
    rail.dataset.recentReady = 'loading';
    const track = rail.querySelector('[data-carousel-track]');
    let pool = rail.querySelector('[data-recent-pool]');
    try {
      const url = new URL(rail.dataset.recentUrl, location.origin);
      url.searchParams.set('section_id', rail.dataset.recentRail);
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Recent product section unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshPool = document.querySelector('[data-recent-pool]');
      if (!freshPool?.content.querySelector('[data-recent-product]')) throw new Error('Empty recent pool');
      pool = freshPool;
      rail.dataset.recentReady = 'fresh';
    } catch (error) {
      // Existing eligible cards stay usable if Shopify's section request fails.
      rail.dataset.recentReady = 'fallback';
    }
    if (!rail.isConnected || !pool) return;
    const chosen = select([...pool.content.querySelectorAll('[data-recent-product]')], Number(rail.dataset.recentCount));
    if (!chosen.length) return;
    track.replaceChildren(...chosen.map(item => item.firstElementChild.cloneNode(true)));
    track.scrollLeft = 0;
    // Refresh existing carousel edge states without replacing its listeners.
    track.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  };
  const scan = (root) => root.querySelectorAll('[data-recent-rail]').forEach(initialise);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
